import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-phone-cell',
  imports: [],
  standalone: true,
  templateUrl: './phone-cell.component.html',
  styleUrl: './phone-cell.component.scss'
})
export class PhoneCellComponent {
  @Input() phone = '';
  @Input() mobilePhone = '';
}
